import { createFileRoute } from '@tanstack/react-router';

import { CurrentWorkPage } from '@/features/work/pages/current-work-page/CurrentWorkPage';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute('/artist/$id/current-work')({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: CurrentWorkPage
});
